//@ts-ignore
import ErrorPage, { PAGE_TYPES } from '@mindtickle/error-page';
//@ts-ignore
import Loader from '@mindtickle/loader';
//@ts-ignore
import PrintError from '@mindtickle/error-page/PrintError';
//@ts-ignore
import { IS_DEV, isDebuggingEnabled } from '@mindtickle/utils';
//@ts-ignore
import { tokens } from '@mindtickle/styles/lib';

import ENV from '~/config/env';
import { EXTERNAL_REMOTES, OTHER_REMOTES } from '../../other-remotes';

export const NAMESPACE = 'ui-shell';
export const APP_NAME = 'ui-shell';

export type TErrorHandlerProps = {
  error: Error;
  message?: string;
};

const generateErrorFallback = (handler: (props: TErrorHandlerProps) => JSX.Element) => ({
  error,
  ...rest
}: TErrorHandlerProps) => {
  if (IS_DEV || isDebuggingEnabled()) {
    return <PrintError error={error} {...rest} />;
  }
  return handler({ error });
};

export const DEFAULT_ERROR_FALLBACK = generateErrorFallback(() => (
  <ErrorPage
    tryAgain={() => window.location?.reload()}
    centered={true}
    pageType={PAGE_TYPES.CLIENT_ERROR}
    showGoToHome={false}
    showLogo={false}
  />
));

export const DEFAULT_DELAYED_FALLBACK = () => <Loader type="Full" />;

export const FRAGMENT_COMPONENT = () => <></>;

export const ROUTES_NAMESPACE = ['new/ui/*', 'new/external-embed/*'];
export const SHAREABLE_ROUTE_PREFIX_PATH = 'sh/:userInteractionId/*';

export const REMOTE_FILE = `${ENV.FEDERATION_REMOTE_FILE_NAME}.js`;

export const DYNAMIC_REMOTES = OTHER_REMOTES;

export const EXTERNAL_REMOTES_APPS = EXTERNAL_REMOTES;

export const PERFORMANCE_MEASURE_NAMES = {
  SHELL_RENDERING_COMPLETED: 'shellRenderingCompleted',
  AUTH_RENDERING_COMPLETED: 'authRenderingCompleted',
  REMOTE_APP_RENDERING_STARTED: 'remoteAppRenderingStarted',
};

export const theme = { prefixCls: tokens.systemTokens.STENCIL_PREFIX_CLS };

export const DEPRECATED_HEADER_OFFSET = 56;

export const BERRY_WIDGET_ID = 'mt-BerryappChatWidget';

// UXR cookie constants
export const UXR_COOKIE_NAME = 'uxr';
export const UXR_COOKIE_EXPIRY_DAYS = 7;
export const UXR_COOKIE_PATH = '/';

export const MT_SHELL_LAYOUT = 'mtShellLayout';

export const HIDDEN = 'hidden';

export const DEFAULT_MAX_WIDTH = {
  MOBILE: 768,
  TABLET: 1024,
  DESKTOP: 1280,
  WIDE_DESKTOP: 1900,
};

export const MT_WEBVIEW = 'MTWebView';
